import styled from 'styled-components';

export const MavieRank = styled.div<{ isNext: boolean }>`
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  ${(props) => props.isNext && '-webkit-filter: grayscale(1); opacity: .5'};
  width: 100%;
  display: flex;
  flex-direction: column;
  > div {
    width: 100%;
    padding: 32px;
  }
  > img {
    width: 100%;
  }
  border-radius: 15px;
  margin-bottom: 40px;
  position: relative;

  @media (max-width: 800px) {
    border-radius: 8px;
    margin-bottom: 20px;

    > div {
      padding: 20px;
    }
  }

  overflow: hidden;
  background: ${(props) => props.theme.colors.neutral50};
`;

export const RankStatus = styled.div`
  position: absolute;
  right: 30px;
  bottom: 30px;
  padding: 10px 20px;
  background: ${({ theme }) => theme.colors.neutral900};
  border-radius: 5px;
  @media (max-width: 800px) {
    padding: 5px 10px;
    bottom: 50%;
    right: 20px;
    transform: translate(0, 50%);
  }
`;

export const Circle = styled.div`
  width: 10px;
  height: 10px;
  margin-left: 10px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex: none;
`;

export const CountdownNumbers = styled.div`
  display: flex;
  align-items: flex-end;
  margin-left: 5px;
`;

export const RankImage = styled.div<{ isActive: boolean; image: any }>`
  position: relative;
  display: flex;
  padding: 50px;
  background-image: ${({ image }) => `url(${image}) `};
  background-color: #000;
  background-size: cover;
  background-repeat: no-repeat;
  aspect-ratio: 1300/260;

  ${({ isActive }) =>
    !isActive &&
    `
   ::before {
    background: rgba(130, 130, 130, 0.56);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  `}

  @media (max-width: 800px) {
    padding: 0;
    align-items: center;
  }
`;
